import { BackgroundColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { createUseStyles } from 'react-jss';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

const useStyles = createUseStyles<string, { backgroundColor: string }>(
  {
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s4,
      backgroundColor: ({ backgroundColor }) => backgroundColor || BackgroundColors.tint1,
      color: TextColors.base,
      borderRadius: CornerRadius.r16,
      maxWidth: 1600,
      width: '100%',
      margin: '0 auto',
      padding: [Spacings.s24, 0],
      '@media screen and (max-width: 425px)': {
        gap: 0,
      },
    },

    container: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: [Spacings.s0, Spacings.s24],
    },

    textContainer: {
      flexGrow: 1,
    },

    title: {
      fontSize: FontSizes.s20,
      fontWeight: FontWeights.bold,
    },

    content: {
      height: 240,
    },

    description: {
      fontSize: FontSizes.s14,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l20,
    },
  },
  { name: 'SuggestedTemplates' },
);

export default useStyles;
